import register from '@kpsys/angularjs-register';

import filterModule from './../filters/filters.module';

import mainMenuComponentModule from './main-menu/main-menu.component.module';
import globalSearchComponentModule from './kp-global-search/kp-global-search.component.module';
import openingCalendarComponentModule from './opening-calendar/kp-opening-calendar.module';
import visitedPanelComponentModule from './kp-visited-panel/kp-visited-panel.module';
import searchInputComponentModule from './kp-search-input/search-input.module';
import loanComponentsModule from './loan/loan.module';
import pdfViewerModule from './kp-pdf-viewer/kp-pdf-viewer.module';
import kpSimilarDocumentsModule from './kp-similar-documents/kp-similar-documents.module';
import kpNewDocumentsModule from './kp-new-documents/kp-new-documents.module';
import kpClipboardModule from './record-clipboard/kp-clipboard-panel.module';

import CarouselComponent from './carousel/carousel.component';
import CollapserComponent from './collapser/collapser.component';
import LinkComponent from './kp-link/kp-link.component';
import StringCollapserComponent from './string-collapser/string-collapser.component';
import PaginatedPanelListComponent from './paginated-panel-list/paginated-panel-list.component';
import JpLinksComponent from './jp-links/jp-links.component';
import KpLazyLoadImgComponent from './kp-lazy-load-img/kp-lazy-load-img.component';
import KpZoomableImageComponent from './kp-zoomable-image/kp-zoomable-image.component';
import KpFileEditorComponent from './kp-file-editor/kp-file-editor.component';
import KpSdiRequestsPanelComponent from './kp-sdi-requests/kp-sdi-requests-panel.component';
import KpSdiRequestListItemComponent from './kp-sdi-requests/kp-sdi-request-list-item.componnet';
import JpSliderComponent from './jp-slider/jp-slider.component';
import KpDocumentsSliderComponent from './kp-documents-slider/kp-documents-slider.component';
import KpVideoViewerComponent from './kp-video-viewer/kp-video-viewer.component';
import KpVideoViewerEventWrapperComponent from './kp-video-viewer/kp-video-viewer-event-wrapper.component';
import KpActionRequestButtonComponent from './kp-action-request-button/kp-action-request-button.component';
import KpCommentsComponent from './kp-comments/kp-comments.component';
import {KpPreformattedTextComponent} from './kp-preformatted-text/kp-preformatted-text.component';
import {KpFavouritesPanelPresenter} from './kp-favourites-panel/kp-favourites-panel.presenter';
import {KpFavouritesButtonPresenter} from './kp-favourites-button/kp-favourites-button.presenter';
import {KpCollectionBulkInsertButtonPresenter} from './kp-record-collection-bulk-insert-button/kp-collection-bulk-insert-button.presenter';
import SettingsItemComponent from '../../use-cases/settings/settings-item.component';
import {
    KpCollectionSingleInsertButtonPresenter
} from './kp-record-collection-single-insert-button/kp-collection-inser-insert-button.presenter';



/**
 * @ngdoc module
 * @name portaro.components
 * @module portaro.components
 */

export default register('portaro.components', [
    filterModule,
    mainMenuComponentModule,
    globalSearchComponentModule,
    openingCalendarComponentModule,
    visitedPanelComponentModule,
    searchInputComponentModule,
    loanComponentsModule,
    pdfViewerModule,
    kpSimilarDocumentsModule,
    kpNewDocumentsModule,
    kpClipboardModule])

    .component(CarouselComponent.componentName, CarouselComponent)
    .component(CollapserComponent.componentName, CollapserComponent)
    .component(LinkComponent.componentName, LinkComponent)
    .component(PaginatedPanelListComponent.componentName, PaginatedPanelListComponent)
    .component(StringCollapserComponent.componentName, StringCollapserComponent)
    .component(JpLinksComponent.componentName, JpLinksComponent)
    .component(KpLazyLoadImgComponent.componentName, KpLazyLoadImgComponent)
    .component(KpZoomableImageComponent.componentName, KpZoomableImageComponent)
    .component(KpFileEditorComponent.componentName, KpFileEditorComponent)
    .component(KpSdiRequestsPanelComponent.componentName, KpSdiRequestsPanelComponent)
    .component(KpSdiRequestListItemComponent.componentName, KpSdiRequestListItemComponent)
    .component(JpSliderComponent.componentName, JpSliderComponent)
    .component(KpDocumentsSliderComponent.componentName, KpDocumentsSliderComponent)
    .component(KpVideoViewerComponent.componentName, KpVideoViewerComponent)
    .component(KpVideoViewerEventWrapperComponent.componentName, KpVideoViewerEventWrapperComponent)
    .component(KpActionRequestButtonComponent.componentName, KpActionRequestButtonComponent)
    .component(KpCommentsComponent.componentName, KpCommentsComponent)
    .component(SettingsItemComponent.componentName,SettingsItemComponent)
    .component(KpPreformattedTextComponent.componentName, KpPreformattedTextComponent)
    .service(KpFavouritesPanelPresenter.presenterName, KpFavouritesPanelPresenter)
    .service(KpFavouritesButtonPresenter.presenterName, KpFavouritesButtonPresenter)
    .service(KpCollectionBulkInsertButtonPresenter.presenterName, KpCollectionBulkInsertButtonPresenter)
    .service(KpCollectionSingleInsertButtonPresenter.presenterName, KpCollectionSingleInsertButtonPresenter)
    .name();
